export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=704ef8a14ac9835e7329d6b776c8ebdd051da0904c&name=pushAdClickData!'